module.exports = __webpack_public_path__ + "img/laboratorio3_4-3.1b729015.jpg";